/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BasketDiscountResponse } from '../../models/basket-discount-response';
import { DiscountResponse } from '../../models/discount-response';
import { QuantityDiscountResponse } from '../../models/quantity-discount-response';
import { SegmentDiscountResponse } from '../../models/segment-discount-response';

export interface GetDiscountById$Params {
  discountId: string;
}

export function getDiscountById(http: HttpClient, rootUrl: string, params: GetDiscountById$Params, context?: HttpContext): Observable<StrictHttpResponse<(DiscountResponse | BasketDiscountResponse | QuantityDiscountResponse | SegmentDiscountResponse)>> {
  const rb = new RequestBuilder(rootUrl, getDiscountById.PATH, 'get');
  if (params) {
    rb.path('discountId', params.discountId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<(DiscountResponse | BasketDiscountResponse | QuantityDiscountResponse | SegmentDiscountResponse)>;
    })
  );
}

getDiscountById.PATH = '/discounts/{discountId}';
